import { useEffect, useRef } from "react";
import { Image, TextLine, Button, FadeTranstion } from '@/components'
import { useNavigate, useLocation } from "react-router-dom";
import { useMobile } from '@/hooks'
import { scrollIntoView } from "@/utils";
import emitter from '@/event';
import shopgeniStart from "@/assets/images/shopgeni-start.png";
import shopgeniDetail from "@/assets/images/shopgeni-detail.png";
import PCandLS from "@/assets/images/PCandLS.png";
import SPandAFD from "@/assets/images/SPandAFD.png";
import ECEandSD from "@/assets/images/ECEandSD.png";
import ANRC from "@/assets/images/ANRC.png";
import PPES from "@/assets/images/PPES.png";
import ACSFI from "@/assets/images/ACSFI.png";
import EECA from "@/assets/images/EECA.jpeg";
import "./style.scss"
import "./style.mobile.scss"

const list1 = [
  {
    image: PCandLS,
    title: "Personalized Clienteling ＆ Loyalty Solutions"
  },
  {
    image: SPandAFD,
    title: "Secure Payments & Advanced Fraud Detection"
  },
  {
    image: ECEandSD,
    title: "Enhanced Customer Experiences & Smart Discovery"
  },
];

function ShopGeni() {
    const navigate = useNavigate();
    const [ isMobile ] = useMobile();
    const location = useLocation();
    const el = useRef<HTMLElement>(null);

    useEffect(() => {
        const scrollHandler = () => {
            scrollIntoView(el.current as HTMLDivElement);
        };
        emitter.on("SCROLL_TO_SHOPGENI", scrollHandler);
        return () => {
            emitter.on("SCROLL_TO_SHOPGENI", scrollHandler);
        };
    }, []);

    useEffect(() => {
        if (location.pathname === "/shopgeni") {
            console.log('el', el.current)
            setTimeout(() => {
                scrollIntoView(el.current as HTMLDivElement);
            }, 20)
        }
    }, [location.pathname]);

    const list2 = [
    {
        image: ANRC,
        title: "A New Revenue Channel: AI-Driven Incremental Demand",
        content: isMobile ? <div>
            - Agent-initiated shopping captures intent before consumers reach traditional search or marketplaces.<br/>
            - ShopGeni routes high-intent buyers directly to your catalog, increasing both top-of-funnel reach and checkout conversion.
        </div> : <div>
            - Agent-initiated shopping captures intent before consumers reach traditional search or marketplaces.<br/>
            - ShopGeni routes high-intent buyers directly to your catalog, increasing both <span className='bold'>top-of-funnel reach</span> and <span className='bold'>checkout conversion</span>.
        </div>
    },
    {
        image: EECA,
        title: "End-to-End Commerce Automation",
        content: <div>
            - ShopGeni integrates Catalog API, Checkout API, and Logistics API, plug merchants directly into AI-native shopping flows.<br/>
            - Reduces friction across discovery → consideration → purchase → post-purchase.
        </div>
    },
    {
        image: PPES,
        title: "Precision Personalization at Enterprise Scale",
        content: <div>
            - Deep understanding of style, fit, occasion, price sensitivity, and brand affinity.<br/>
            - AI builds “micro-segments of one,” improving attach rates, AOV, and margin mix.
        </div>
    },
    {
        image: ACSFI,
        title: "Agentic Commerce as a Strategic Future Investment",
        content: <div>
            - Forecast to $4T Agentic Commerce by 2030, reshaping e-commerce economics.<br/>
            - Early partnership positions you as an Agentic Commerce leader, rather than a follower.
        </div>
    },
    ];

    const list3 = [
    {
        image: ANRC,
        title: "A New Revenue Channel: AI-Driven Incremental Demand",
        content: isMobile ? <div>
            - Agent-initiated shopping captures intent before consumers reach traditional search or marketplaces.<br/>
            - ShopGeni routes high-intent buyers directly to your catalog, increasing both top-of-funnel reach and checkout conversion.
        </div> : <div>
            - Agent-initiated shopping captures intent before consumers reach traditional search or marketplaces.<br/>
            - ShopGeni routes high-intent buyers directly to your catalog, increasing both <span className='bold'>top-of-funnel reach</span> and <span className='bold'>checkout conversion</span>.
        </div>
    },
    {
        image: PPES,
        title: "Precision Personalization at Enterprise Scale",
        content: <div>
            - Deep understanding of style, fit, occasion, price sensitivity, and brand affinity.<br/>
            - AI builds “micro-segments of one,” improving attach rates, AOV, and margin mix.
        </div>
    },
    {
        image: EECA,
        title: "End-to-End Commerce Automation",
        content: <div>
            - ShopGeni integrates Catalog API, Checkout API, and Logistics API, plug merchants directly into AI-native shopping flows.<br/>
            - Reduces friction across discovery → consideration → purchase → post-purchase.
        </div>
    },
    {
        image: ACSFI,
        title: "Agentic Commerce as a Strategic Future Investment",
        content: <div>
            - Forecast to $4T Agentic Commerce by 2030, reshaping e-commerce economics.<br/>
            - Early partnership positions you as an Agentic Commerce leader, rather than a follower.
        </div>
    },
    ];

    return (
        <section className="shopgeni-container" ref={el}>
            <p className="title">ShopGeni<span className="point"></span></p>
            {isMobile ?
                <p className="subtitle">
                    ShopGeni is the world's first end-to-end LLM based multimodel AI Agent, enables complex, scenario-driven product discovery and seamless agentic checkout.
                </p> : 
                <p className="subtitle">
                    <TextLine>ShopGeni</TextLine> is the world's first end-to-end LLM based<br/>
                    multimodel AI Agent, enables complex, scenario-driven<br/>
                    product discovery and seamless agentic checkout.
                </p>
            }
            <FadeTranstion>
                <Image className="shopgeni-start" src={shopgeniStart}></Image>
            </FadeTranstion>
            <FadeTranstion>
                <Image className="shopgeni-chat" src={shopgeniDetail}></Image>
            </FadeTranstion>
            <Button className="demo-btn" onClick={() => window.open('https://www.beyondstyle.us/shopgeni')}>Contact Us For Demo</Button>
            <p className="title SRandBS">
                Supports Retailers and<br/>
                Brands Strategy
            </p>
            <FadeTranstion>
                <ul className="list1">
                    {list1.map((item) => (
                        <li className="shopgeni-list1-item" key={item.title}>
                            <Image className="shopgeni-list1-img" src={item.image}></Image>
                            <h4 className="text-title">{item.title}</h4>
                        </li>
                    ))}
                </ul>
            </FadeTranstion>
            <FadeTranstion>
                <ul className="list2">
                    {(isMobile ? list3 : list2).map((item) => (
                        <li className="shopgeni-list2-item" key={item.title}>
                            <Image className="shopgeni-list2-img" src={item.image}></Image>
                            <h4 className="text-title">{item.title}</h4>
                            <p className="text-content">{item.content}</p>
                        </li>
                    ))}
                </ul>
            </FadeTranstion>
            <Button onClick={() => navigate("/contact-us")}>Contact Us</Button>
        </section>
    )
}

export default ShopGeni